import { OWNER_ROLE_LABEL } from '../constant/role.constant';
import { IUser } from '../interfaces/user.interface';

export const getRoleLabel = (user: IUser): string | null =>
    user.isOwner ? OWNER_ROLE_LABEL : user.roleName;
